export enum LayoutType {
  APP = "App"
}
